export const CLIENT_ROUTE = '/modify-request/song';
export const API_ROUTE = '/api/song-modify-request';
export const CLIENT_TITLE = 'Дуу засварлах хүсэлт';